import { Trans } from '@lingui/macro'
import React, { Fragment, FunctionComponent } from 'react'
import { useSessionContext } from '../contexts/SessionProvider'
import DownloadResults from './DownloadResults'

const MainDownload: FunctionComponent = () => {
  const { session, error, loading } = useSessionContext()

  return (
    <Fragment>
      <div className='container my-4'>
        {error !== '' ? (
          <h4 data-testid='errorMessage'>{error}</h4>
        ) : loading ? (
          <h4 data-testid='validatingMessage'>
            <Trans>Validando permisos...</Trans>
          </h4>
        ) : (
          <DownloadResults idSurvey={session?.survey_id as string} />
        )}
      </div>
    </Fragment>
  )
}
export default MainDownload
